import axiosInstance from "@/api/axiosConfig";
import { handleAPIError } from "@/api/utils/errors";

import type {
  CustomCaseType,
  CustomCaseTypeInput,
  CustomCaseTypesResponse
} from "./types";

const base = (lawFirmId: string) =>
  `/law_firms/${encodeURIComponent(lawFirmId)}/custom-case-types`;

const call = async <T>(run: () => Promise<{ data: T }>): Promise<T> => {
  try {
    return (await run()).data;
  } catch (error) {
    throw handleAPIError(error);
  }
};

/** `/api/law_firms/<id>/custom-case-types`: members read, owners and admins write. */
export const customCaseTypesApi = {
  list: (lawFirmId: string) =>
    call(() => axiosInstance.get<CustomCaseTypesResponse>(base(lawFirmId))),
  create: (lawFirmId: string, input: CustomCaseTypeInput) =>
    call(() => axiosInstance.post<CustomCaseType>(base(lawFirmId), input)),
  update: (lawFirmId: string, id: string, input: CustomCaseTypeInput) =>
    call(() =>
      axiosInstance.put<CustomCaseType>(
        `${base(lawFirmId)}/${encodeURIComponent(id)}`,
        input
      )
    ),
  duplicate: (lawFirmId: string, id: string) =>
    call(() =>
      axiosInstance.post<CustomCaseType>(
        `${base(lawFirmId)}/${encodeURIComponent(id)}/duplicate`,
        {}
      )
    ),
  remove: (lawFirmId: string, id: string) =>
    call(() =>
      axiosInstance.delete<{ deleted: CustomCaseType }>(
        `${base(lawFirmId)}/${encodeURIComponent(id)}`
      )
    )
};
